var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{staticClass:"wbs-loading"},[_c('div',{staticClass:"wbs-loading__indicator"},[_c('i',{staticClass:"mdi mdi-spin mdi-loading"}),_vm._v(" Carregando... ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }